import React from "react";
import Hero from "../components/Hero";
import Disciplines from "../components/Disciplines";
import About from "../components/About";
import SelectedWork from "../components/SelectedWork";
import MapAU from "../components/MapAU";
import Estimator from "../components/Estimator";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import JournalPreview from "../components/JournalPreview";
import Contact from "../components/Contact";
import useReveal from "../components/useReveal";

export default function Home() {
  useReveal();
  return (
    <main data-testid="page-home">
      <Hero />
      <Disciplines />
      <About />
      <SelectedWork />
      <MapAU />
      <Estimator />
      <Process />
      <Testimonials />
      <JournalPreview />
      <Contact />
    </main>
  );
}
